import { MessageEditStatus, type Msg, type Session } from '@halo/chat-sdk-react';
import { MessageEdit } from '@halo/ui-chat-react';
import { useStaticAppStore } from '@/store/client';

export interface MsgFooterEditProps {
  session: Session;
  message: Msg;
}

export const MsgFooterEdit = memo(function MsgFooterEdit({
  session,
  message,
}: MsgFooterEditProps) {
  const { client } = useStaticAppStore();

  const isFailed = useMemo(() => message?.edit === MessageEditStatus.Failed, [message?.edit]);
  const isEditing = useMemo(() => message?.edit === MessageEditStatus.Editing, [message?.edit]);

  return (
    <MessageEdit
      isEditing={isEditing}
      isFailed={isFailed}
      onClickError={() => {
        client?.Api.messages.resendMessageEdit(session!.chat_id, message.message_id);
      }}
    />
  );
});
